var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DropdownActionItem',{staticClass:"flex items-center",attrs:{"data-test-id":"skip"},on:{"click":_vm.onSkip}},[_c('SkipAction',{scopedSlots:_vm._u([{key:"default",fn:function({ skip }){return [_c('Icon',{staticClass:"mr-1",attrs:{"name":"eye-slashed"}}),_vm._v(" Skip ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }